import React from 'react';
import { Link } from 'react-router-dom';
import { Result, Button } from 'antd';

import { useAuth } from '../authentication/AuthProvider';

/** Unknown address: say so instead of silently landing on the workspace. */
export default function NotFoundPage() {
  const auth = useAuth();
  const home = auth.user ? (auth.user.role === 'CLIENT_ADMIN' ? '/portal' : '/') : '/auth/login';
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result
        status="404"
        title="Page not found"
        subTitle={`There is nothing at ${window.location.pathname}. Check the address, or go back to the workspace.`}
        extra={
          <Link to={home}>
            <Button type="primary">{auth.user ? 'Go to Workspace' : 'Sign in'}</Button>
          </Link>
        }
      />
    </div>
  );
}
